import { Link } from 'react-router-dom';
import ArtistLinks from './ArtistLinks';
import { Icon } from '../components/Icons';
import { trackEvent } from '../utils/analytics';
import { useGiveaway } from '../features/giveaways/GiveawayProvider';
import { requestSlotReward } from '../features/giveaways/giveawayApi';

export default function FeaturedTrackSlots({
    tracks = [],
    slotCount = 8,
    onPlayTrack,
}) {
    const hasAvailableSlots = tracks.length < slotCount;

    const slots = [
        ...tracks,
        ...(hasAvailableSlots ? [null] : []),
    ];
    const { showRewardToken } = useGiveaway();
    return (
        <div className="bjnt-featured-track-slots">
            {slots.map((track, index) => (
                <article
                    key={track?.id || `empty-${index}`}
                    className={`bjnt-featured-track-slot ${track ? 'is-filled' : 'is-empty'
                        }`}
                >
                    {track ? (
                        <>
                            <button
                                type="button"
                                className="bjnt-featured-track-slot__play"
                                onClick={async () => {
                                    const promotionalTrack = {
                                        ...track,
                                        isFeatured: true,
                                    };

                                    trackEvent('featured_track_play', {
                                        track_id: track.id,
                                        track_title: track.title,
                                        slot_index: index + 1,
                                    });

                                    onPlayTrack?.(promotionalTrack, index);

                                    try {
                                        const reward = await requestSlotReward(
                                            'featured_track_play',
                                            'featured_track_play'
                                        );

                                        if (reward?.alreadyCollected) return;
                                        if (!reward?.success || !reward?.token) return;

                                        showRewardToken(reward.token);
                                    } catch (error) {
                                        // ignore
                                    }
                                }}
                            >
                                <Icon name="play" size={36} />
                            </button>

                            <Link
                                to={`/track/${track.slug}`}
                                className="bjnt-featured-track-slot__cover"
                            >
                                {track.cover ? (
                                    <img src={track.cover} alt="" />
                                ) : (
                                    <span />
                                )}
                            </Link>

                            <div className="bjnt-featured-track-slot__body">
                                <p>Featured Track</p>

                                <h3>
                                    <Link to={`/track/${track.slug}`}>
                                        {track.title}
                                    </Link>
                                </h3>

                                <ArtistLinks
                                    artists={track.artists}
                                    fallback={track.artist}
                                    className="bjnt-track-artists"
                                />
                            </div>
                        </>
                    ) : (
                        <div className="bjnt-featured-track-slot__empty">
                            <p>Featured Track Slot</p>

                            <h3>Your track could be here</h3>

                            <span>
                                Promote your Crop Over release on Bajantube.
                            </span>

                            <a
                                href="mailto:advertise@bajantube.com?subject=Featured%20Track%20Slot"
                                className="bjnt-featured-track-slot__book"
                            >
                                Get Featured
                            </a>
                        </div>
                    )}
                </article>
            ))}
        </div>
    );
}